import { render, staticRenderFns } from "./carv4wardsettings.vue?vue&type=template&id=c6b10116&"
import script from "./carv4wardsettings.vue?vue&type=script&lang=js&"
export * from "./carv4wardsettings.vue?vue&type=script&lang=js&"
import style0 from "./carv4wardsettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports